/**
 * 西暦から和暦に変換します
 * @param {number} westernYear - 西暦年
 * @returns {Object} 元号と元号での年数
 */
export const convertWesternToJapanese = (westernYear) => {
  if (isNaN(westernYear) || westernYear < 1868) {
    return { era: "", eraYear: 0 };
  }

  if (westernYear >= 2019) {
    return { era: "令和", eraYear: westernYear - 2018 };
  } else if (westernYear >= 1989) {
    return { era: "平成", eraYear: westernYear - 1988 };
  } else if (westernYear >= 1926) {
    return { era: "昭和", eraYear: westernYear - 1925 };
  } else if (westernYear >= 1912) {
    return { era: "大正", eraYear: westernYear - 1911 };
  } else if (westernYear >= 1868) {
    return { era: "明治", eraYear: westernYear - 1867 };
  }

  return { era: "", eraYear: 0 };
};

/**
 * 和暦から西暦に変換します
 * @param {string} era - 元号（reiwa, heisei, showa, taisho, meiji）
 * @param {number} eraYear - 元号年
 * @returns {number} 西暦年
 */
export const convertJapaneseToWestern = (era, eraYear) => {
  if (isNaN(eraYear) || eraYear < 1) {
    return 0;
  }

  switch (era) {
    case "reiwa":
      return eraYear + 2018;
    case "heisei":
      return eraYear + 1988;
    case "showa":
      return eraYear + 1925;
    case "taisho":
      return eraYear + 1911;
    case "meiji":
      return eraYear + 1867;
    default:
      return 0;
  }
};

/**
 * 相対年を計算します
 * @param {number} targetYear - 対象年
 * @param {number} currentYear - 現在年
 * @returns {string} 相対年の表示
 */
export const getRelativeYear = (targetYear, currentYear) => {
  if (targetYear === currentYear) {
    return "今年";
  } else if (targetYear === currentYear + 1) {
    return "来年";
  } else if (targetYear === currentYear - 1) {
    return "去年";
  } else if (targetYear > currentYear) {
    return `${targetYear - currentYear}年後`;
  } else {
    return `${currentYear - targetYear}年前`;
  }
};

/**
 * 元号年を元号表記に変換します (例: 1 → 元)
 * @param {number} eraYear - 元号年
 * @returns {string} 元号表記
 */
export const formatEraYear = (eraYear) => {
  return eraYear === 1 ? "元" : String(eraYear);
};

/**
 * 元号の開始・終了年と計算オフセットを取得します
 * @returns {Array} 元号情報の配列
 */
export const getEraData = (maxYear = new Date().getFullYear() + 10) => {
  return [
    { name: '令和', start: 2019, end: maxYear + 1, offset: 2018 },
    { name: '平成', start: 1989, end: 2019, offset: 1988 },
    { name: '昭和', start: 1926, end: 1989, offset: 1925 },
    { name: '大正', start: 1912, end: 1926, offset: 1911 },
    { name: '明治', start: 1868, end: 1912, offset: 1867 }
  ];
};

/**
 * 重複年の特別処理用データを取得します
 * @returns {Object} 重複年マッピングデータ
 */
export const getOverlapYearsData = () => {
  return {
    2019: { '令和': 1, '平成': 31 },
    1989: { '平成': 1, '昭和': 64 },
    1926: { '昭和': 1, '大正': 15 },
    1912: { '大正': 1, '明治': 45 }
  };
}; 